
const numberToTwoDecimals = (num) => {
  return Number.isFinite(num) ? Number.parseFloat(num).toFixed(2) : '-'
}

export {
  numberToTwoDecimals
}
